export const contactInfo = {
    phone: "+45 50 16 17 64",
    email: "renza.denmark@gmail.com",
    area: "Copenhagen, Frederiksberg, Amager, Nordhavn, Ørestad, Nørrebro, Vesterbro, Hvidovre and nearby areas",
};
export const routes = {
    da: {
        home: "/",
        services: "/ydelser",
        sustainability: "/baeredygtighed",
        about: "/om-os",
        contact: "/kontakt",
        quote: "/faa-tilbud",
        faq: "/faq",
        blog: "/blog",
        privacy: "/privatlivspolitik",
        cookies: "/cookiepolitik",
        how: "/saadan-fungerer-det",
    },
    en: {
        home: "/en",
        services: "/en/services",
        sustainability: "/en/sustainability",
        about: "/en/about",
        contact: "/en/contact",
        quote: "/en/request-quote",
        faq: "/en/faq",
        blog: "/en/blog",
        privacy: "/en/privacy-policy",
        cookies: "/en/cookie-policy",
        how: "/en/how-it-works",
    },
};
export const nav = {
    da: [
        ["Ydelser", "/ydelser"],
        ["Bæredygtighed", "/baeredygtighed"],
        ["Sådan fungerer det", "/saadan-fungerer-det"],
        ["Om os", "/om-os"],
        ["FAQ", "/faq"],
        ["Kontakt", "/kontakt"],
    ],
    en: [
        ["Services", "/en/services"],
        ["Sustainability", "/en/sustainability"],
        ["How it works", "/en/how-it-works"],
        ["About", "/en/about"],
        ["FAQ", "/en/faq"],
        ["Contact", "/en/contact"],
    ],
};
export const services = [
    {
        key: "office",
        primary: true,
        daSlug: "/kontorrengoering",
        enSlug: "/en/office-cleaning",
        icon: "building",
        titleDa: "Kontorrengøring",
        titleEn: "Office cleaning",
        forDa: "For kontorer, administrationer og virksomheder med faste arbejdspladser.",
        forEn: "For offices, administrations and companies with regular workplaces.",
        includesDa: [
            "Skriveborde og overflader",
            "Mødelokaler",
            "Køkkenområder",
            "Toiletter",
            "Affaldshåndtering",
            "Støvsugning og gulvvask",
            "Dørhåndtag og kontaktpunkter",
            "Mulighed for månedlig hovedrengøring",
        ],
        includesEn: [
            "Desks and surfaces",
            "Meeting rooms",
            "Kitchen areas",
            "Toilets",
            "Waste handling",
            "Vacuuming and mopping",
            "Door handles and touch points",
            "Monthly deep cleaning option",
        ],
        frequencyDa: "Dagligt, flere gange ugentligt eller ugentligt.",
        frequencyEn: "Daily, several times per week or weekly.",
        painDa: "Holder kontoret præsentabelt, sundt og klar til medarbejdere og gæster.",
        painEn: "Keeps the office presentable, healthy and ready for employees and guests.",
    },
    {
        key: "coworking",
        primary: true,
        daSlug: "/kontorfaellesskab-rengoering",
        enSlug: "/en/coworking-cleaning",
        icon: "users",
        titleDa: "Rengøring af kontorfællesskaber",
        titleEn: "Coworking space cleaning",
        forDa: "For coworking spaces, office hotels and shared workspaces.",
        forEn: "For coworking spaces, office hotels and shared workspaces.",
        includesDa: [
            "Fælles skriveborde",
            "Mødelokaler",
            "Fællesområder",
            "Køkkener og kaffeområder",
            "Toiletter",
            "Eventrengøring",
            "Daglig reset-rengøring",
            "Aftenrengøring efter medlemmerne er gået",
        ],
        includesEn: [
            "Shared desks",
            "Meeting rooms",
            "Common areas",
            "Kitchens and coffee areas",
            "Toilets",
            "Event cleaning",
            "Daily reset cleaning",
            "Evening cleaning after members leave",
        ],
        frequencyDa: "Typisk dagligt eller flere gange om ugen.",
        frequencyEn: "Usually daily or several times per week.",
        painDa: "Skaber en stabil standard i lokaler med høj aktivitet og mange brugere.",
        painEn: "Creates a stable standard in high-traffic spaces with many users.",
    },
    {
        key: "project-office",
        primary: true,
        daSlug: "/projektkontor-rengoering",
        enSlug: "/en/project-office-cleaning",
        icon: "hardhat",
        titleDa: "Rengøring af projektkontor",
        titleEn: "Project office cleaning",
        forDa: "For midlertidige byggepladskontorer, projektlokaler og skurbyer.",
        forEn: "For temporary site offices, project rooms and construction office facilities.",
        includesDa: [
            "Midlertidige site offices",
            "Projektmødelokaler",
            "Personale-køkkener/kantiner",
            "Toiletter og omklædning",
            "Støvkontrol",
            "Affaldshåndtering",
            "Slutrengøring før aflevering",
            "Fleksible korttidsaftaler",
        ],
        includesEn: [
            "Temporary site offices",
            "Project meeting rooms",
            "Staff kitchens/canteens",
            "Toilets and changing areas",
            "Dust control cleaning",
            "Waste handling",
            "Final cleaning before handover",
            "Flexible short-term contracts",
        ],
        frequencyDa: "Fleksibelt efter projektets fase og belastning.",
        frequencyEn: "Flexible depending on the project phase and activity level.",
        painDa: "Reducerer støv og rod, så projektteamet kan arbejde i ordentlige rammer.",
        painEn: "Reduces dust and mess so project teams can work in orderly surroundings.",
    },
    {
        key: "home",
        daSlug: "/privat-rengoering",
        enSlug: "/en/home-cleaning",
        icon: "home",
        titleDa: "Privat rengøring",
        titleEn: "Private home cleaning",
        forDa: "For private hjem, lejligheder og familier.",
        forEn: "For private homes, apartments and families.",
        includesDa: [
            "Køkken",
            "Bad",
            "Aftørring",
            "Støvsugning",
            "Gulvvask",
            "Overflader",
            "Engangs- eller fast aftale",
        ],
        includesEn: [
            "Kitchen cleaning",
            "Bathroom cleaning",
            "Dusting",
            "Vacuuming",
            "Floor washing",
            "Surface cleaning",
            "One-time or recurring cleaning",
        ],
        frequencyDa: "Ugentligt, månedligt eller efter behov.",
        frequencyEn: "Weekly, monthly or as needed.",
        painDa: "Gør hverdagen lettere med stabil og respektfuld rengøring.",
        painEn: "Makes everyday life easier with reliable and respectful cleaning.",
    },
    {
        key: "move",
        daSlug: "/flytterengoering",
        enSlug: "/en/move-out-cleaning",
        icon: "key",
        titleDa: "Flytterengøring",
        titleEn: "Move-in / move-out cleaning",
        forDa: "For tomme boliger før indflytning eller aflevering.",
        forEn: "For empty homes before moving in or handover.",
        includesDa: [
            "Grundig rengøring af tom bolig",
            "Køkken og hårde hvidevarer",
            "Bad",
            "Skabe og overflader",
            "Gulve",
            "Afsluttende tjek",
        ],
        includesEn: [
            "Deep cleaning of empty homes",
            "Kitchen and appliance cleaning",
            "Bathroom cleaning",
            "Cabinet and surface cleaning",
            "Floor cleaning",
            "Final check before handover",
        ],
        frequencyDa: "Engangsopgave.",
        frequencyEn: "One-time cleaning.",
        painDa: "Sparer tid og skaber en tryg aflevering.",
        painEn: "Saves time and creates a confident handover.",
    },
    {
        key: "stairs",
        daSlug: "/trappevask",
        enSlug: "/en/staircase-cleaning",
        icon: "stairs",
        titleDa: "Trappevask",
        titleEn: "Staircase cleaning",
        forDa: "For ejendomme, boligforeninger og opgange.",
        forEn: "For properties, housing associations and entrances.",
        includesDa: [
            "Trappevask",
            "Indgangspartier",
            "Gelændere",
            "Dørhåndtag",
            "Postkasser/fællesområder",
            "Ugentlige eller månedlige planer",
        ],
        includesEn: [
            "Stair washing",
            "Entrance areas",
            "Handrails",
            "Door handles",
            "Mailbox/common areas",
            "Weekly or monthly plans",
        ],
        frequencyDa: "Ugentligt eller månedligt.",
        frequencyEn: "Weekly or monthly.",
        painDa: "Holder fællesarealer pæne og trygge for beboere og gæster.",
        painEn: "Keeps shared areas neat and comfortable for residents and guests.",
    },
    {
        key: "clinic",
        daSlug: "/klinikrengoering",
        enSlug: "/en/clinic-cleaning",
        icon: "cross",
        titleDa: "Klinikrengøring",
        titleEn: "Clinic cleaning",
        forDa: "For klinikker, behandlerrum og modtageområder.",
        forEn: "For clinics, treatment rooms and reception areas.",
        includesDa: [
            "Reception",
            "Venterum",
            "Behandlingsrum",
            "Toiletter",
            "Kontaktpunkter",
            "Omhyggelige rutiner",
        ],
        includesEn: [
            "Reception areas",
            "Waiting rooms",
            "Treatment rooms",
            "Toilets",
            "High-touch surfaces",
            "Careful cleaning routines",
        ],
        frequencyDa: "Efter behov og åbningstider.",
        frequencyEn: "Based on needs and opening hours.",
        painDa: "Omhyggelig rengøring uden at påstå medicinsk desinfektion uden dokumentation.",
        painEn: "Careful routines without unsupported medical-grade disinfection claims.",
    },
    {
        key: "shop",
        daSlug: "/butik-showroom-rengoering",
        enSlug: "/en/shop-showroom-cleaning",
        icon: "store",
        titleDa: "Butik og showroom",
        titleEn: "Shop and showroom cleaning",
        forDa: "For butikker, showrooms og kundevendte lokaler.",
        forEn: "For shops, showrooms and customer-facing spaces.",
        includesDa: [
            "Kundeområder",
            "Udstillingsflader",
            "Gulve",
            "Prøverum hvis relevant",
            "Indvendigt glas hvis aftalt",
            "Personaleområder",
        ],
        includesEn: [
            "Customer areas",
            "Display surfaces",
            "Floors",
            "Fitting rooms if relevant",
            "Interior glass if agreed",
            "Staff areas",
        ],
        frequencyDa: "Fast eller efter events/kampagner.",
        frequencyEn: "Recurring or after events/campaigns.",
        painDa: "Sikrer at kunder møder et rent og roligt førsteindtryk.",
        painEn: "Ensures customers meet a clean and calm first impression.",
    },
    {
        key: "deep",
        daSlug: "/hovedrengoering",
        enSlug: "/en/deep-cleaning",
        icon: "sparkle",
        titleDa: "Hovedrengøring",
        titleEn: "Deep cleaning",
        forDa: "For virksomheder og private med behov for en grundigere indsats.",
        forEn: "For businesses and private customers needing a deeper clean.",
        includesDa: [
            "Detaljeret køkken/bad",
            "Svært tilgængelige områder",
            "Fodpaneler",
            "Kontaktpunkter",
            "Indvendige skabe efter aftale",
            "Engangsplan",
        ],
        includesEn: [
            "Detailed kitchen/bathroom cleaning",
            "Hard-to-reach areas",
            "Baseboards",
            "Touch points",
            "Interior cabinets if requested",
            "One-time cleaning plan",
        ],
        frequencyDa: "Engangsopgave eller periodisk supplement.",
        frequencyEn: "One-time or periodic add-on.",
        painDa: "Fjerner ophobet snavs og får rummet tilbage til en bedre standard.",
        painEn: "Removes built-up dirt and brings the space back to a better standard.",
    },
    {
        key: "final",
        daSlug: "/slutrengoering-renovering",
        enSlug: "/en/renovation-final-cleaning",
        icon: "check",
        titleDa: "Slutrengøring efter renovering",
        titleEn: "Final cleaning after renovation",
        forDa: "For renoveringer, mindre byggeprojekter og aflevering.",
        forEn: "For renovations, smaller construction projects and handover.",
        includesDa: [
            "Støvfjerning",
            "Overflader",
            "Gulve",
            "Slutrengøring før brug eller aflevering",
            "Projektbaseret tilbud",
        ],
        includesEn: [
            "Dust removal",
            "Surface cleaning",
            "Floor cleaning",
            "Final clean before use or handover",
            "Project-based quote",
        ],
        frequencyDa: "Projektbaseret.",
        frequencyEn: "Project-based.",
        painDa: "Gør lokalet klar til brug uden at love urealistiske resultater.",
        painEn: "Makes the space ready for use without unrealistic promises.",
    },
];
export const faq = {
    da: [
        [
            "Gør I rent uden for normal arbejdstid?",
            "Ja, vi kan planlægge rengøring morgen, aften eller weekend efter aftale.",
        ],
        [
            "Gør I rent på kontorer?",
            "Ja, kontorrengøring er et af vores primære fokusområder i København.",
        ],
        [
            "Gør I rent i kontorfællesskaber?",
            "Ja, vi laver fleksible planer til kontorfællesskaber og office hotels.",
        ],
        [
            "Gør I rent i byggeplads- og projektkontorer?",
            "Ja, vi hjælper med midlertidige projektkontorer, møderum, køkkener og toiletter.",
        ],
        [
            "Gør I rent i private hjem?",
            "Ja, Renza er også egnet til private hjem og lejligheder.",
        ],
        [
            "Tilbyder I flytterengøring?",
            "Ja, vi tilbyder flytterengøring som engangsopgave.",
        ],
        [
            "Medbringer I rengøringsprodukter?",
            "Ja, normalt medbringer vi produkter og materialer efter aftale.",
        ],
        [
            "Er produkterne miljøvenlige?",
            "Vi prioriterer danskproducerede og miljøvenlige produkter, hvor det er muligt.",
        ],
        [
            "Tilbyder I hovedrengøring?",
            "Ja, både som engangsopgave og som supplement til fast rengøring.",
        ],
        [
            "Kan vi få en fast månedlig rengøringsplan?",
            "Ja, vi kan lave en fast plan med checklist, frekvens og opfølgning.",
        ],
        [
            "Får vi en rengøringscheckliste?",
            "Ja, vi arbejder efter klare checklist, så forventningerne er tydelige.",
        ],
        [
            "Hvordan får vi en pris?",
            "Send en forespørgsel, så vurderer vi type, størrelse, frekvens og behov.",
        ],
        [
            "Hvilke områder dækker I?",
            "København, Frederiksberg, Amager, Nordhavn, Ørestad, Nørrebro, Vesterbro, Hvidovre og nærområder.",
        ],
        [
            "Kan vi booke aften- eller weekendrengøring?",
            "Ja, det kan aftales ud fra opgaven og teamets plan.",
        ],
    ],
    en: [
        [
            "Do you clean outside normal working hours?",
            "Yes, we can schedule cleaning in the morning, evening or weekend by agreement.",
        ],
        [
            "Do you clean offices?",
            "Yes, office cleaning is one of our primary focus areas in Copenhagen.",
        ],
        [
            "Do you clean coworking spaces?",
            "Yes, we create flexible plans for coworking spaces and office hotels.",
        ],
        [
            "Do you clean construction project offices?",
            "Yes, we help with temporary site offices, meeting rooms, kitchens and toilets.",
        ],
        [
            "Do you clean private homes?",
            "Yes, Renza can also clean private homes and apartments.",
        ],
        [
            "Do you offer move-out cleaning?",
            "Yes, we offer move-in and move-out cleaning as one-time work.",
        ],
        [
            "Do you bring your own cleaning products?",
            "Yes, we normally bring products and materials by agreement.",
        ],
        [
            "Are your products eco-friendly?",
            "We prioritize Danish-made and eco-friendly products where possible.",
        ],
        [
            "Do you offer one-time deep cleaning?",
            "Yes, both as a one-time service and as an add-on to recurring cleaning.",
        ],
        [
            "Can we get a fixed monthly cleaning plan?",
            "Yes, we can create a fixed plan with checklist, frequency and follow-up.",
        ],
        [
            "Do you provide a cleaning checklist?",
            "Yes, we use clear checklists so expectations are easy to follow.",
        ],
        [
            "How do we get a price?",
            "Send a request and we assess space type, size, frequency and needs.",
        ],
        [
            "Which areas do you cover?",
            "Copenhagen, Frederiksberg, Amager, Nordhavn, Ørestad, Nørrebro, Vesterbro, Hvidovre and nearby areas.",
        ],
        [
            "Can we book evening or weekend cleaning?",
            "Yes, depending on the assignment and team schedule.",
        ],
    ],
};
export const blogPosts = [
    [
        "How often should an office be cleaned?",
        "how-often-should-an-office-be-cleaned",
        "Office cleaning frequency depends on team size, use and visitor traffic.",
        "Renza",
        "2026-05-15",
        "Office cleaning",
        ["office", "Copenhagen"],
        4,
    ],
    [
        "Office cleaning checklist for Copenhagen businesses",
        "office-cleaning-checklist-copenhagen-businesses",
        "A practical checklist for clean, healthy and presentable offices.",
        "Renza",
        "2026-05-15",
        "Guides",
        ["checklist", "office"],
        5,
    ],
    [
        "Why coworking spaces need a different cleaning routine",
        "coworking-spaces-cleaning-routine",
        "Shared workspaces need reset routines and flexible schedules.",
        "Renza",
        "2026-05-15",
        "Coworking",
        ["coworking"],
        4,
    ],
    [
        "Eco-friendly cleaning for modern workplaces",
        "eco-friendly-cleaning-modern-workplaces",
        "How responsible product choices support modern workplaces.",
        "Renza",
        "2026-05-15",
        "Sustainability",
        ["eco-friendly"],
        4,
    ],
    [
        "Project office cleaning on construction sites",
        "project-office-cleaning-construction-sites",
        "Keep temporary project offices orderly during busy construction phases.",
        "Renza",
        "2026-05-15",
        "Project offices",
        ["construction"],
        3,
    ],
    [
        "Move-out cleaning checklist in Denmark",
        "move-out-cleaning-checklist-denmark",
        "A simple preparation checklist for moving out.",
        "Renza",
        "2026-05-15",
        "Home cleaning",
        ["move-out"],
        5,
    ],
    [
        "How to prepare your home for professional cleaning",
        "prepare-home-for-professional-cleaning",
        "Small preparations that help cleaners focus on cleaning.",
        "Renza",
        "2026-05-15",
        "Home cleaning",
        ["home"],
        3,
    ],
    [
        "Why Danish-made cleaning products matter",
        "why-danish-made-cleaning-products-matter",
        "Local product choices can support quality, availability and responsibility.",
        "Renza",
        "2026-05-15",
        "Sustainability",
        ["Danish-made"],
        4,
    ],
    [
        "How to choose a reliable cleaning company in Copenhagen",
        "choose-reliable-cleaning-company-copenhagen",
        "What to look for when choosing a cleaning partner.",
        "Renza",
        "2026-05-15",
        "Buying guide",
        ["Copenhagen"],
        5,
    ],
];
